import React from "react"
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from "@mui/material"
import { useSelector } from "react-redux"
import moment from "moment"
import CommonModal from "components/CommonModal"
import TableNoRecords from "components/TableNoRecords"

const SpreeDataModal = ({ open, onClose }) => {
  const { spreeWindowData } = useSelector((state) => state.superAdmin)
  const { isLoading } = useSelector((state) => state.app)

  const spree = spreeWindowData?.spree
  const totals = spreeWindowData?.totals
  const rewards = spreeWindowData?.rewards || []

  const dateRange =
    spree?.spree_start_date && spree?.spree_end_date
      ? `${moment(spree.spree_start_date).format("MMM DD, YYYY")} – ${moment(
          spree.spree_end_date
        ).format("MMM DD, YYYY")}`
      : ""

  return (
    <CommonModal open={open} onClose={onClose} maxWidth="md" hideAction>
      <Box sx={{ mb: 2, textAlign: "center" }}>
        <Typography variant="h6" fontWeight={600}>
          Shopping Spree Data
        </Typography>
        {dateRange && (
          <Typography variant="body2Regular" color="text.secondary">
            {dateRange}
          </Typography>
        )}
      </Box>

      {totals && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            mb: 2,
            px: 2,
            py: 1.5,
            borderRadius: "12px",
            backgroundColor: "rgba(255, 255, 255, 0.04)"
          }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2Regular" color="text.secondary">
              Total Quantity
            </Typography>
            <Typography variant="h6">{totals.total_quantity}</Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2Regular" color="text.secondary">
              Redeemed
            </Typography>
            <Typography variant="h6">{totals.redeemed}</Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2Regular" color="text.secondary">
              Available
            </Typography>
            <Typography variant="h6">{totals.available}</Typography>
          </Box>
        </Box>
      )}

      <TableContainer sx={{ maxHeight: 420 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Reward", "Tier", "Total", "Redeemed", "Available"].map((label, i) => (
                <TableCell key={label} align={i > 1 ? "right" : "left"}>
                  <Typography variant="body2Regular" sx={{ opacity: 0.6 }}>
                    {label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rewards.length ? (
              rewards.map((r) => (
                <TableRow key={r.gift_card_id}>
                  <TableCell>
                    <Typography variant="body2Regular">{r.name}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2Regular">{r.tier_name || "-"}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2Regular">
                      {r.is_set ? r.total_quantity : "Not set"}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2Regular">{r.redeemed}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2Regular">{r.available}</Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableNoRecords
                colSpan={5}
                label={isLoading ? "Loading spree data..." : "No reward data for this spree."}
              />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CommonModal>
  )
}

export default SpreeDataModal
